var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padi",
    transform: "translate(0.199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-0.199)",
    fill: "#fec328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M3240.993,191.663s-1.364-8.1,3.75-13.937,10.234-6.61,10.234-6.61",
    transform: "translate(-3227.084 -160.399)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,11.814A12.59,12.59,0,0,1,3,4.472,16.541,16.541,0,0,1,10.623,0",
    transform: "translate(18.507 19.224) rotate(9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(12.314 9.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M3211.976,398.052a4.347,4.347,0,0,1-1.326-1.881,3.068,3.068,0,0,1,.428-2.01,2.433,2.433,0,0,1,1.24,1.454A5.275,5.275,0,0,1,3211.976,398.052Z",
    transform: "translate(-3210.603 -382.218)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1.175,3.331A3.72,3.72,0,0,1,.04,1.72,2.627,2.627,0,0,1,.406,0,2.083,2.083,0,0,1,1.468,1.245,4.512,4.512,0,0,1,1.175,3.331Z",
    transform: "translate(16.455 0.502) rotate(81)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1.076,3.05A3.406,3.406,0,0,1,.037,1.575,2.406,2.406,0,0,1,.372,0a1.907,1.907,0,0,1,.972,1.14A4.132,4.132,0,0,1,1.076,3.05Z",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, 13.274, 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1.191,3.377A3.771,3.771,0,0,1,.041,1.744,2.663,2.663,0,0,1,.412,0,2.111,2.111,0,0,1,1.488,1.262,4.574,4.574,0,0,1,1.191,3.377Z",
    transform: "translate(10.848 0.781) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1.191,3.377A3.771,3.771,0,0,1,.041,1.744,2.663,2.663,0,0,1,.412,0,2.111,2.111,0,0,1,1.488,1.262,4.574,4.574,0,0,1,1.191,3.377Z",
    transform: "translate(8.023 2.114) rotate(30)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1.335,3.784A4.225,4.225,0,0,1,.046,1.954,2.984,2.984,0,0,1,.462,0,2.366,2.366,0,0,1,1.667,1.414,5.125,5.125,0,0,1,1.335,3.784Z",
    transform: "translate(5.691 3.782) rotate(25)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1.335,3.784A4.225,4.225,0,0,1,.046,1.954,2.984,2.984,0,0,1,.462,0,2.366,2.366,0,0,1,1.667,1.414,5.125,5.125,0,0,1,1.335,3.784Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 3.391, 6.08)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1.37,3.883A4.337,4.337,0,0,1,.047,2.006,3.063,3.063,0,0,1,.474,0,2.428,2.428,0,0,1,1.711,1.451,5.26,5.26,0,0,1,1.37,3.883Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 1.606, 8.767)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M.969,0A3.067,3.067,0,0,0,.033,1.328a2.166,2.166,0,0,0,.3,1.418A1.717,1.717,0,0,0,1.21,1.72,3.72,3.72,0,0,0,.969,0Z",
    transform: "translate(12.135 4.101) rotate(-103)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1,0A3.162,3.162,0,0,0,.034,1.369,2.233,2.233,0,0,0,.345,2.832a1.77,1.77,0,0,0,.9-1.058A3.835,3.835,0,0,0,1,0Z",
    transform: "translate(9.937 5.296) rotate(-104)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1.218,0A3.444,3.444,0,0,0,.042,1.457,2.148,2.148,0,0,0,.421,3.013a2.015,2.015,0,0,0,1.1-1.126A3.619,3.619,0,0,0,1.218,0Z",
    transform: "translate(8.058 7.039) rotate(-111)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1.365,0A3.861,3.861,0,0,0,.047,1.633,2.408,2.408,0,0,0,.472,3.377,2.258,2.258,0,0,0,1.706,2.115,4.057,4.057,0,0,0,1.365,0Z",
    transform: "translate(6.393 9.144) rotate(-120)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1.316,0A3.721,3.721,0,0,0,.045,1.574a2.32,2.32,0,0,0,.41,1.681A2.176,2.176,0,0,0,1.644,2.039,3.909,3.909,0,0,0,1.316,0Z",
    transform: "matrix(-0.616, -0.788, 0.788, -0.616, 4.881, 11.279)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1.553,0a4.391,4.391,0,0,0-1.5,1.857A2.738,2.738,0,0,0,.537,3.841a2.568,2.568,0,0,0,1.4-1.435A4.613,4.613,0,0,0,1.553,0Z",
    transform: "translate(3.779 14.241) rotate(-133)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1.553,0a4.391,4.391,0,0,0-1.5,1.857A2.738,2.738,0,0,0,.537,3.841a2.568,2.568,0,0,0,1.4-1.435A4.613,4.613,0,0,0,1.553,0Z",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 3.162, 17.085)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(18.785 17.427) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M.976,2.766A3.089,3.089,0,0,1,.033,1.429,2.182,2.182,0,0,1,.337,0a1.729,1.729,0,0,1,.882,1.034A3.747,3.747,0,0,1,.976,2.766Z",
    transform: "translate(0 8.49)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M.835,2.368A2.644,2.644,0,0,1,.029,1.223,1.867,1.867,0,0,1,.289,0a1.48,1.48,0,0,1,.755.885A3.207,3.207,0,0,1,.835,2.368Z",
    transform: "translate(11.697 0.357) rotate(81)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M.765,2.168A2.422,2.422,0,0,1,.026,1.12,1.71,1.71,0,0,1,.264,0,1.356,1.356,0,0,1,.956.81,2.937,2.937,0,0,1,.765,2.168Z",
    transform: "translate(9.435 0) rotate(52)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M.847,2.4A2.681,2.681,0,0,1,.029,1.24,1.893,1.893,0,0,1,.293,0a1.5,1.5,0,0,1,.765.9A3.252,3.252,0,0,1,.847,2.4Z",
    transform: "translate(7.711 0.555) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M.847,2.4A2.681,2.681,0,0,1,.029,1.24,1.893,1.893,0,0,1,.293,0a1.5,1.5,0,0,1,.765.9A3.252,3.252,0,0,1,.847,2.4Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 5.702, 1.503)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-2",
    "data-name": "Path 15",
    d: "M.949,2.69a3,3,0,0,1-.916-1.3A2.121,2.121,0,0,1,.328,0a1.682,1.682,0,0,1,.857,1A3.643,3.643,0,0,1,.949,2.69Z",
    transform: "translate(4.045 2.688) rotate(25)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16",
    d: "M.949,2.69a3,3,0,0,1-.916-1.3A2.121,2.121,0,0,1,.328,0a1.682,1.682,0,0,1,.857,1A3.643,3.643,0,0,1,.949,2.69Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 2.41, 4.322)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17",
    d: "M.974,2.761a3.083,3.083,0,0,1-.94-1.335A2.177,2.177,0,0,1,.337,0a1.726,1.726,0,0,1,.88,1.031A3.739,3.739,0,0,1,.974,2.761Z",
    transform: "translate(1.141 6.232) rotate(10)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    d: "M.689,0A2.18,2.18,0,0,0,.024.944,1.54,1.54,0,0,0,.238,1.952,1.22,1.22,0,0,0,.86,1.223,2.644,2.644,0,0,0,.689,0Z",
    transform: "matrix(-0.225, -0.974, 0.974, -0.225, 8.626, 2.916)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M.71,0A2.248,2.248,0,0,0,.024.973a1.587,1.587,0,0,0,.221,1.04,1.258,1.258,0,0,0,.641-.752A2.726,2.726,0,0,0,.71,0Z",
    transform: "matrix(-0.242, -0.97, 0.97, -0.242, 7.063, 3.765)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14",
    d: "M.866,0A2.449,2.449,0,0,0,.03,1.036,1.527,1.527,0,0,0,.3,2.142a1.432,1.432,0,0,0,.782-.8A2.572,2.572,0,0,0,.866,0Z",
    transform: "matrix(-0.358, -0.934, 0.934, -0.358, 5.728, 5.004)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18",
    d: "M.971,0A2.745,2.745,0,0,0,.033,1.161a1.711,1.711,0,0,0,.3,1.24,1.605,1.605,0,0,0,.877-.9A2.884,2.884,0,0,0,.971,0Z",
    transform: "translate(4.544 6.501) rotate(-120)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-2",
    "data-name": "Path 19",
    d: "M.935,0a2.645,2.645,0,0,0-.9,1.119A1.649,1.649,0,0,0,.323,2.314a1.547,1.547,0,0,0,.845-.864A2.779,2.779,0,0,0,.935,0Z",
    transform: "translate(3.469 8.018) rotate(-128)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20-2",
    "data-name": "Path 20",
    d: "M1.1,0A3.121,3.121,0,0,0,.038,1.32,1.946,1.946,0,0,0,.382,2.73a1.825,1.825,0,0,0,1-1.02A3.279,3.279,0,0,0,1.1,0Z",
    transform: "translate(2.686 10.124) rotate(-133)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-2",
    "data-name": "Path 21",
    d: "M1.1,0A3.121,3.121,0,0,0,.038,1.32,1.946,1.946,0,0,0,.382,2.73a1.825,1.825,0,0,0,1-1.02A3.279,3.279,0,0,0,1.1,0Z",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.247, 12.146)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M3182.463,351.568a21.539,21.539,0,0,1-1.155-6.243,17.636,17.636,0,0,1,1.155-5.858,24.68,24.68,0,0,0-.342,7.227,19.3,19.3,0,0,0,1.325,5.131Z",
    transform: "translate(-3170.806 -320.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M3260.834,510.5c-.165-.822,1.052-4.243,1.052-4.243s-.592,3.552-.3,4.506S3261,511.327,3260.834,510.5Z",
    transform: "translate(-3246.176 -479.785)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M0,0H14.9",
    transform: "translate(10.498 31.266)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1408",
    "data-name": "Line 1408",
    x2: 8.762,
    transform: "translate(14.002 33.076)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadi);
export default __webpack_public_path__ + "static/media/padi.690448dc9750b7c410ae1afb90501347.svg";
export { ForwardRef as ReactComponent };